module.exports = __webpack_public_path__ + "static/media/arbeitsmittel.994d6d0f.jpg";